module.exports = __webpack_public_path__ + "img/sbg0101.f9b3a717.png";